export default __webpack_public_path__ + "static/media/amex.02517bb0.svg";